/**
 * Validates colour selection
 * @param {string} v
 * @param {object} state
 * @returns {*}
 */
const colourValidator = (v, state) => {
  const quizType = localStorage.getItem('quiz-type');

  if (quizType === 'supplement') {
    const { yourFormulation: formulation = "" } = state;
    const hasGreenTeaExtract = formulation.includes('Green Tea Extract');

    if (hasGreenTeaExtract) {
      return "This colour is not available because your formula contains green tea extract. Please choose another colour or remove green tea extract from your formula.";
    }
  }

  if (quizType === 'haircare') {
    const {chooseUpToThreeHairGoals: goals} = state;
    const isBrassiness = goals.filter((goal) => goal.includes('brassiness'));

    if (isBrassiness.length > 0 && v !== 'Brassiness pigment') {
      return "Because you chose a reduce brassiness hair goal, your formulations already contain pigment and so you can't select another colour.";
    }
  }

  return !!v || 'Field is required.';
};

/**
 * Validates hair goals
 * @param {array} v
 * @returns {*}
 */
const goalValidator = (v) => {
  if (v.length > 3) {
    return 'Oops! A maximum of three goals can be selected at once. Please unselect one of your goals if you’d like to select another.';
  }

  const brassiness = v && v.filter((g) => g.includes('Reduce brassiness')).length > 1;

  if (brassiness) {
    return 'Oops! Only one reduce-brassiness goal can be selected at once. Please choose one or the other.';
  }

  return true;
};

export { colourValidator, goalValidator };
